export default __webpack_public_path__ + "static/easy-and-fast-to-set-up-4f573b641a6fb39e10fcacbbad43f60f.gif";